@if (eventFeed(); as feed) {
  @if (feed.enabled) {
    <section class="mt-10">
      <div class="flex items-center justify-between mb-6 px-1">
        <h3 class="text-xl font-semibold">{{ feed.title }}</h3>
        @if (feed.showLiveIndicator) {
          <span class="text-xs text-muted-color live-feed-indicator">
            Live feed
            <span class="relative inline-flex h-2 w-2 items-center justify-center" aria-hidden="true">
              <span class="absolute inline-flex h-2 w-2 rounded-full bg-red-500 opacity-75 animate-ping"></span>
              <span class="relative inline-flex h-2 w-2 rounded-full bg-red-500"></span>
            </span>
          </span>
        }
      </div>
      @if (displayedUserEvents(); as events) {
        @if (events.length === 0) {
          <p class="text-muted-color text-sm px-1">No recent selections yet.</p>
        } @else {
          <p-carousel
            [value]="events"
            orientation="vertical"
            verticalViewPortHeight="18rem"
            [numVisible]="3"
            [numScroll]="3"
            [circular]="events.length > 1"
            [autoplayInterval]="events.length > 1 ? 6000 : undefined"
            [showIndicators]="true"
            [showNavigators]="false"
            styleClass="rounded-2xl border border-surface-200 bg-white shadow-sm overflow-hidden user-events-feed-carousel"
          >
            <ng-template #item let-event>
              <div class="px-4 py-3 flex items-center gap-3 feed-card border-b border-surface-200" [class.border-b-0]="events.indexOf(event) % 3 === 2">
                <div class="relative h-12 w-12 shrink-0 overflow-hidden rounded-xl bg-surface-100 border border-surface-200">
                  <img homeyImage="thumbnail" [homeyImageSrc]="event.photo" alt="Lottery photo" class="h-full w-full object-cover"/>
                </div>
                <div class="flex flex-col flex-1">
                  <div class="flex flex-row justify-between gap-1 align-bottom">
                    <span class="text-base font-semibold">{{ event.displayName }} from {{ event.borough | boroughToText}}</span>
                    <span class="text-muted-color text-sm">{{ formatRelativeTime(event.createdAt) }}</span>
                  </div>
                  <span class="text-sm text-surface-500 event-description">
                Was selected for a {{ event.unitLabel }} at {{ event.lottery.name }}@if (event.includeLocation) {, {{ event.location }} }@if (feed.showEmoji) { <span class="ml-1">{{ event.emoji }}</span> }
              </span>
                </div>
              </div>
            </ng-template>
          </p-carousel>
        }
      } @else {
        <div class="rounded-2xl border border-surface-200 bg-white shadow-sm overflow-hidden h-72">
          <div class="divide-y divide-surface-200">
            @for (placeholder of skeletonPlaceholders; track placeholder) {
              <div class="px-4 py-3 flex items-center gap-3 h-24">
                <p-skeleton height="3rem" width="3rem" borderRadius="0.75rem"></p-skeleton>
                <div class="flex-1 space-y-2">
                  <p-skeleton height="1.1rem" width="70%"></p-skeleton>
                  <p-skeleton height="0.9rem" width="90%"></p-skeleton>
                </div>
                <p-skeleton height="0.9rem" width="3.5rem"></p-skeleton>
              </div>
            }
          </div>
        </div>
      }
    </section>
  }
}
